export type HubspotPreDefinedType = "account" | "contact";

export type SalesforcePreDefinedType = "account" | "contact" | "lead" | "company-as-lead";

export type DynamicsPreDefinedType = "account" | "contact" | "lead" | "company-as-lead";

export type PreDefinedResponse = {
    dataType: string;
    pickListItems: Record<string, string>;
    label: string;
    name: string;
    isRequired: boolean;
}[];

const ACCOUNT_SOURCE = 1;
export const CONTACT_SOURCE = 2;
const PREDEFINED_SOURCE = 3;
const TECHNOLOGIES_SOURCE = 4;
const DATA_REQUESTER_SOURCE = 5;
const SUBSIDIARIES_SOURCE = 6;
const STATIC_LIST_SOURCE = 7;
const SCORING_SOURCE = 8;
const PREDEFINED_CREATE_SOURCE = 9;
const PREDEFINED_UPDATE_SOURCE = 10;

export enum ExportSettingsSourceType {
    Account = ACCOUNT_SOURCE,
    Contact = CONTACT_SOURCE,
    Predefined = PREDEFINED_SOURCE,
    Technologies = TECHNOLOGIES_SOURCE,
    DataRequester = DATA_REQUESTER_SOURCE,
    Subsidiaries = SUBSIDIARIES_SOURCE,
    StaticList = STATIC_LIST_SOURCE,
    Scoring = SCORING_SOURCE,
    PredefinedCreate = PREDEFINED_CREATE_SOURCE,
    PredefinedUpdate = PREDEFINED_UPDATE_SOURCE,
}
